/**
 * Frontend role-based permission map.
 * mirrors node/_helpers/permissions.js — keep in sync.
 *
 * Rules:
 *  - Venue owner (role falsy / 'owner') → always permitted.
 *  - Staff → look up their role in the map below.
 */

const ROLE_PERMISSIONS = {
  manager: ['pos', 'settle', 'orders', 'menu', 'modifiers', 'reports', 'qr', 'customers', 'settings', 'staff', 'tables', 'tables_assign'],
  server:  ['pos', 'settle', 'orders', 'tables'],
  kitchen: ['orders'],
};

/**
 * can(role, perm) — returns true when:
 *   - role is falsy or 'owner' (venue owner always passes), OR
 *   - the staff role includes the permission.
 *
 * @param {string|null|undefined} role  - 'owner', 'manager', 'server', 'kitchen', or falsy
 * @param {string}                perm  - permission key e.g. 'pos', 'menu', 'staff'
 * @returns {boolean}
 */
export function can(role, perm) {
  if (!role || role === 'owner') return true;
  return (ROLE_PERMISSIONS[role] || []).includes(perm);
}

export default ROLE_PERMISSIONS;
